module.exports = __webpack_public_path__ + "img/error.61d88861.png";